module.exports = __webpack_public_path__ + "img/loader.09227892.svg";